import { Box, styled } from "@mui/material";

import { withDefaultProps } from "fond/utils/withDefaultProps";

const PaletteBox = withDefaultProps(Box, { width: 35, height: 15 });

export const Container = styled(PaletteBox, {
  shouldForwardProp: (prop) => prop !== "colors",
})<{ colors: string[] }>(
  ({ colors }) => `
    background: linear-gradient(90deg, ${colors.join(",")});
    border-radius: 2px;
  `
);
